

export class TourAllocationOutputWithStatus implements ITourAllocationOutputWithStatus {
    /** The auto-generated id of the tour allocation master */
    tour_allocation_id!: number;
    /** The auto-generated id of the tour master */
    tour_id!: number;
    /** The tour name 255 character limit */
    trip_name!: string;
    /** The tour schedule type  should be Relative, Fixed or Automatic */
    tour_schedule_type!: string;
    /** The vehicle number with 255 character limit */
    vehicle_number!: string;
    /** The company name with 255 character */
    company_name!: string;
    /** The branch name with 255 character */
    branch!: string;
    /** The start point 5000 character limit */
    start_point!: string;
    /** The trip start point 25 character limit */
    trip_start_time!: string;
    /** The distance */
    distance!: number;
    /** The duration 10 character limit */
    duration!: string;
    /** Total point path */
    total_stop_point!: string;
    /** The status of poi details should be 0 or 1 */
    status!: number;

    constructor(data?: ITourAllocationOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_allocation_id = _data["tour_allocation_id"];
            this.tour_id = _data["tour_id"];
            this.trip_name = _data["trip_name"];
            this.tour_schedule_type = _data["tour_schedule_type"];
            this.vehicle_number = _data["vehicle_number"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.start_point = _data["start_point"];
            this.trip_start_time = _data["trip_start_time"];
            this.distance = _data["distance"];
            this.duration = _data["duration"];
            this.total_stop_point = _data["total_stop_point"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TourAllocationOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TourAllocationOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_allocation_id"] = this.tour_allocation_id;
        data["tour_id"] = this.tour_id;
        data["trip_name"] = this.trip_name;
        data["tour_schedule_type"] = this.tour_schedule_type;
        data["vehicle_number"] = this.vehicle_number;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["start_point"] = this.start_point;
        data["trip_start_time"] = this.trip_start_time;
        data["distance"] = this.distance;
        data["duration"] = this.duration;
        data["total_stop_point"] = this.total_stop_point;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITourAllocationOutputWithStatus {
    /** The auto-generated id of the tour allocation master */
    tour_allocation_id: number;
    /** The auto-generated id of the tour master */
    tour_id: number;
    /** The tour name 255 character limit */
    trip_name: string;
    /** The tour schedule type  should be Relative, Fixed or Automatic */
    tour_schedule_type: string;
    /** The vehicle number with 255 character limit */
    vehicle_number: string;
    /** The company name with 255 character */
    company_name: string;
    /** The branch name with 255 character */
    branch: string;
    /** The start point 5000 character limit */
    start_point: string;
    /** The trip start point 25 character limit */
    trip_start_time: string;
    /** The distance */
    distance: number;
    /** The duration 10 character limit */
    duration: string;
    /** Total point path */
    total_stop_point: string;
    /** The status of poi details should be 0 or 1 */
    status: number;
}

